import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { locations, projectList, bbsList, fetchProject, newProject,editProjectUser,editProject } from './api';
import { message } from 'antd';

const initialState = {
  allProjectList: [],
  locations: [],
  bbsList: [],
  initialState: {
    isApprovalView: false,
  },
  loading: false,
};

const actions = {
  GET_PROJECT_LIST: 'GET_PROJECT_LIST',
  GET_LOCATIONS: 'GET_LOCATIONS',
  GET_BBS_LIST: 'GET_BBS_LIST',
  FETCH_PROJECT:'FETCH_PROJECT',
  NEW_PROJECT:'NEW_PROJECT',
  EDIT_PROJECT_USER:'EDIT_PROJECT_USER',
  EDIT_PROJECT:'EDIT_PROJECT',
};

export const getProjectList = createAsyncThunk(
  actions.GET_PROJECT_LIST,
  async (payload) => {
    const response = await projectList(payload);
    return response;
  },
);

export const getLocations = createAsyncThunk(
  actions.GET_LOCATIONS,
  async (payload) => {
    const response = await locations(payload);
    return response;
  },
);

export const getBbsList = createAsyncThunk(
  actions.GET_BBS_LIST,
  async (payload) => {
    const response = await bbsList(payload);
    return response;
  },
);

export const fetchProjectList = createAsyncThunk(
  actions.FETCH_PROJECT,
  async (payload) => {
    const response = await fetchProject(payload);
    return response;
  },
);

export const createNewProject = createAsyncThunk(
  actions.NEW_PROJECT,
  async ({ payload, type }) => {
    const response = await newProject(payload,type);
    return response;
  },
);

export const fetchEditProjectUser = createAsyncThunk(
  actions.EDIT_PROJECT_USER,
  async ({ payload, id }) => {
    const response = await editProjectUser(payload, id);
    return response;
  }
);

export const fetchEditProject = createAsyncThunk(
  actions.EDIT_PROJECT,
  async ({ payload, id }) => {
    const response = await editProject(payload, id);
    return response;
  }
);
export const requestApprovalSlice = createSlice({
  name: 'requestApproval',
  initialState,
  reducers: {
    setApprovalView: (state, action) => {
      state.isApprovalView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.loading = false;
        state.allProjectList = action.payload;
      })
      .addCase(getProjectList.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch project list.');
      });
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(getLocations.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch Locations');
      });

    builder
      .addCase(getBbsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBbsList.fulfilled, (state, action) => {
        state.loading = false;
        state.bbsList = action.payload;
      })
      .addCase(getBbsList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch BbsList');
      });

      builder
      .addCase(fetchProjectList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjectList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchProjectList.rejected, (state, action) => {
        //const { message: msg } = action.error;
        state.loading = false;
        //message.error(action.error?.message || 'Failed to fetch Projects');
      });

      builder
      .addCase(createNewProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewProject.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createNewProject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch Projects');
      });

      builder
      .addCase(fetchEditProjectUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEditProjectUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchEditProjectUser.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch Projects');
      });

      builder
      .addCase(fetchEditProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEditProject.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchEditProject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(action.error?.message || 'Failed to fetch Projects');
      });
  },
});

export const { setApprovalView } = requestApprovalSlice.actions;
export default requestApprovalSlice.reducer;
